import { render } from "./TvmMultiSelectSuggestions.vue?vue&type=template&id=677f21b8&scoped=true"
import script from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmMultiSelectSuggestions.js?vue&type=script&lang=js&external"

import "./TvmMultiSelectSuggestions.vue?vue&type=style&index=0&id=677f21b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f21b8"],['__file',"src/Components/ChatWidget/TvmMultiSelectSuggestions/TvmMultiSelectSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "677f21b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('677f21b8', __exports__)) {
    api.reload('677f21b8', __exports__)
  }
  
  module.hot.accept("./TvmMultiSelectSuggestions.vue?vue&type=template&id=677f21b8&scoped=true", () => {
    api.rerender('677f21b8', render)
  })

}


export default __exports__